export default function client(window) {
    const {screen, navigator} = window;
    const result = {
        entryType: 'client',
        screenRes: `${screen.width}x${screen.height}`,
        availScreenRes: `${screen.availWidth}x${screen.availHeight}`,
        windowInner: `${window.innerWidth}x${window.innerHeight}`,
        windowOuter: `${window.outerWidth}x${window.outerHeight}`
    };
    const {orientation} = screen;
    if (orientation && orientation.type) {
        result.orientation = orientation.type;
    }
    const {connection, deviceMemory, hardwareConcurrency} = navigator;
    if (hardwareConcurrency) {
        result.cores = hardwareConcurrency;
    }
    if (deviceMemory) {
        result.memory = deviceMemory;
    }
    if (connection) {
        const {type, effectiveType, rtt, downlink, saveData} = connection;
        if (type) {
            result.type = type;
        }
        if (effectiveType) {
            result.effectiveType = effectiveType;
        }
        if (rtt) {
            result.rtt = rtt;
        }
        if (downlink) {
            result.download = Math.round(downlink);
        }
        if (typeof saveData === 'boolean') {
            result.saveData = saveData;
        }
    }
    return Promise.resolve(result);
}
